import { globalStyle, style } from '../layer.css.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { ellipsis } from '../utility.css.ts';

export const streamPackageCardV2 = style({
  position: 'relative',
  justifyContent: 'space-between',
  gap: space.s16,
  height: '100%',
});

export const streamPackageCardV2Main = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  width: '100%',
  minWidth: 0,
});

export const streamPackageCardV2Cover = style({
  position: 'relative',
  display: 'block',
  width: '100%',
  height: 175,
  overflow: 'hidden',
  flexShrink: 0,
  borderRadius: borderRadius.r8,
  backgroundColor: '#000',
});

globalStyle(`${streamPackageCardV2Cover}::after`, {
  content: '',
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  pointerEvents: 'none',
  borderRadius: 'inherit',
  boxShadow: hairline('rgba(255, 255, 255, 0.1)'),
});

export const streamPackageCardV2CoverImage = style({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const streamPackageCardV2Tags = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  minWidth: 0,
  flexWrap: 'wrap',
});

export const streamPackageCardV2Body = style({
  gap: space.s8,
});

export const streamPackageCardV2Title = style({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const streamPackageCardV2Description = style({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const streamPackageCardV2Streams = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  width: '100%',
  minWidth: 0,
  padding: space.s12,
  backgroundColor: themeV2.color.bg.surface.secondary,
  boxShadow: hairline(themeV2.color.border.subtle),
  borderRadius: borderRadius.r16,
});

export const streamPackageCardV2StreamGrid = style({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
  gridTemplateRows: 'repeat(3, auto)',
  gridAutoFlow: 'column',
  columnGap: space.s16,
  rowGap: space.s8,
  width: '100%',
  minWidth: 0,
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

export const streamPackageCardV2StreamRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  minWidth: 0,
});

export const streamPackageCardV2StreamIcon = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  flexShrink: 0,
  borderRadius: borderRadius.r8,
  boxShadow: hairline('rgba(255, 255, 255, 0.1)'),
  color: themeV2.color.text.secondary,
});

export const streamPackageCardV2MoreIcon = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  flexShrink: 0,
  borderRadius: borderRadius.r8,
  color: themeV2.color.text.quaternary,
});

globalStyle(
  `.${streamPackageCardV2StreamIcon} :where(svg), .${streamPackageCardV2MoreIcon} :where(svg)`,
  {
    width: 12,
    height: 12,
    flexShrink: 0,
  },
);

export const streamPackageCardV2StreamName = style([
  ellipsis,
  {
    ...typography.bodySm,
    color: themeV2.color.text.secondary,
  },
]);

export const streamPackageCardV2MoreLabel = style({
  ...typography.bodySm,
  color: themeV2.color.text.quaternary,
});

export const streamPackageCardV2Meta = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: space.s12,
  flexShrink: 0,
});
